import { render } from "./jygz.vue?vue&type=template&id=9b4482a2&scoped=true"
import script from "./jygz.vue?vue&type=script&lang=js"
export * from "./jygz.vue?vue&type=script&lang=js"

import "./jygz.vue?vue&type=style&index=0&id=9b4482a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4482a2"]])

export default __exports__